<template>
  <div class="header" :class="{ 'header-teacher' : !user.isParent() }">
    <div class="container-fluid">
      <div class="row align-items-center position-relative d-flex justify-content-between">

        <div class="header-left col-auto d-flex align-items-center justify-content-center">
          <img v-if="!isAuthorized || isAuthorized && user.isParent()" class="logo-header" src="~assets/img/logo-header.svg">
          <a v-else :href="logoUrl">
            <span v-if="!user.isParent()" class="header-go-back text-right icon-teacher-green">
              <chevron-left/>
            </span>
            <img class="logo-header" src="~assets/img/logo-header.svg">
          </a>

          <div @click="openList" v-if="user.isParent() && isAuthorized" class="header-title ml-4 btn-cursor underlined">
            <h4 class="pinboard-title">
              {{ pinboard.title }}
              <img v-if="pinboards_list.length > 1"
                :src="'./static/img/' + user.role + '/arrow_dropdown.png'"
                :class="{ rotated: open_list }"
                alt="">
            </h4>
            <h5 class="pinboard-subtitle">{{ pinboard.subtitle }}</h5>

            <div class="pinboard-picker" :class="{ open: open_list }">
              <div v-for="pin in pinboards_list"
                   v-if="pin.code !== pinboard.code"
                   @click="setPinboard(pin.itemid, pin.code)"
                   class="pinboard-option btn-cursor">
                <h4 class="pinboard-title">{{ pin.title }}</h4>
                <h5 class="pinboard-subtitle">{{ pin.subtitle }}</h5>
              </div>
            </div>

          </div>
          <h4 v-if="!user.isParent() && isAuthorized && pinboard.itemid" class="header-title ml-4">
            {{ pinboard.title }}
          </h4>

        </div>

        <div v-if="isAuthorized && pinboard.itemid" class="header-center">
          <h4 class="header-title header-title--hovered ml-2">
            <a :href="`https://www.klassenpinnwand.at/${pinboard.itemid}`" target="_blank">Klassenpinnwand</a>
          </h4>
          <h4 class="header-title ml-4 header-title-underlined">
            <router-link :to="{ name: 'home' }" class="navi-link">
              hallo! Nachrichten
              <span v-if="!user.isParent()" class="unread-messages">{{ pinboard.nr_messages }}</span>
              <span v-else class="unread-messages unread-messages-parent">{{ pinboard.nr_messages }}</span>
            </router-link>
          </h4>
        </div>

        <div class="header-right col-auto">
          <ul v-if="isAuthorized" class="navi" :class="{ active: active_nav }">
            <li v-if="user.isParent()" class="navi-item">
              <button v-b-modal.modal-assign-student class="navi-link" :class="{ 'link-teacher-green' : !user.isParent() }">
                <!-- <img class="logo-header" :src="'./static/img/' + user.role + '/child.png'"> -->
                <face-icon/><span class="navin-link-text">Kind hinzufügen</span>
              </button>
            </li>
            <li v-else-if="pinboard.itemid" class="navi-item">
              <router-link :to="{ name: 'student-list' }" class="navi-link" :class="{ 'link-teacher-green' : !user.isParent() }">
                <!-- <img class="logo-header" :src="'./static/img/' + user.role + '/child.png'"> -->
                <face-icon/><span class="navin-link-text">Schülerliste</span>
              </router-link>
            </li>
            <li v-if="pinboard.itemid" class="navi-item">
              <router-link :to="{ name: 'settings' }" class="navi-link" :class="{ 'link-teacher-green' : !user.isParent() }">
                <!-- <img class="logo-header" :src="'./static/img/' + user.role + '/nav_settings.png'"> -->
                <settings-icon/><span class="navin-link-text">Einstellungen</span>
              </router-link>
            </li>
            <li class="navi-item">
              <a v-if="user.parent" href="https://www.klassenpinnwand.at/support/faq-eltern" target="_blank" class="navi-link" :class="{ 'link-teacher-green' : !user.isParent() }">
                <help-circle/><span class="navin-link-text">FAQ</span>
              </a>
              <a v-else href="https://klassenpinnwand.at/support/faq-lehrer" target="_blank" class="navi-link" :class="{ 'link-teacher-green' : !user.isParent() }">
                <help-circle/><span class="navin-link-text">FAQ</span>
              </a>
            </li>
            <li class="navi-item">
              <b-link @click="logout()" class="navi-link">Abmelden</b-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-modal id="modal-assign-student" @change="clearModal()" size="md" centered class="app-modals" title="Kind hinzufügen" hide-footer ref="addChildModal">
      <assign-child ref="addTestModal" @exit="closeModal"/>
    </b-modal>

  </div>
</template>

<script>
// API
import account from '@/api/v1/account';
import pinboardApi from '@/api/v1/pinboard';
// Components
import AssignChild from '@/components/Student/Assign';
import FaceIcon from 'vue-material-design-icons/face';
import SettingsIcon from 'vue-material-design-icons/settings';
import ChevronLeft from 'vue-material-design-icons/chevron-left';
import HelpCircle from 'vue-material-design-icons/help-circle';

export default {
  components: { AssignChild, FaceIcon, SettingsIcon, ChevronLeft, HelpCircle },
  data() {
    return {
      user: account.user,
      active_nav: false,
      pinboard: {
        nr_messages: 0,
        title: '',
      },
      open_list: false,
      pinboards_list: [],
      authorized: false,
    };
  },
  computed: {
    isAuthorized() {
      if (this.authorized) return true;
      const user = account.user;
      return user.isParent() ? (user.isAuthenticated() && user.isConfirmed()) : user.isAuthenticated();
    },
    logoUrl() {
      return process.env.KLASSENPINNWAND_URL;
    },
  },
  methods: {
    logout() {
      account.logout();
    },
    clearModal() {
      this.$refs.addTestModal.clearData();
    },
    getPinboardDetails() {
      pinboardApi.show((data) => {
        if (data.detailresponse) this.pinboard = data.detailresponse;
        if (data.statuscode === 404) {
          this.$bus.pinboardNotFound();
        }
      }, account.user.child);
    },
    getPinboardsList() {
      if (this.isAuthorized) {
        pinboardApi.index((data) => {
          if (data.listresponse.length === 0 && account.user.isParent()) {
            this.$router.push({ name: 'user_deactivated' });
          }
          this.pinboards_list = data.listresponse;
        });
      }
    },
    setPinboard(itemid, code) {
      localStorage.setItem('Pinboard-Id', itemid);
      localStorage.setItem('Child-Code', code);
      location.href = '';
    },
    openList() {
      if (this.pinboards_list.length > 1) this.open_list = !this.open_list;
    },
    closeModal() {
      this.$refs.addChildModal.hide();
    },
  },
  mounted() {
    const vm = this;
    this.$bus.$on('get:unreaded', () => { vm.getPinboardDetails(); });
    this.$bus.$on('get:pinboards', () => { vm.getPinboardsList(); });
    this.$bus.$on('login:success', () => { this.authorized = true; });
  },
  created() {
    this.getPinboardDetails();
    this.getPinboardsList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/Index.vue